import React from "react";
import "./style.css";
import CustomButtonWithIcon from "../../../../../../dentail-indetifcation/components/d-reusable/CustomButtonWithIcon";
import { assessmentIcons } from "../../../../../utils/assessmentIcons";
import { parseStageDescription } from "../../../../../../helper";

const StageCriteria = ({ stage, stageMatched, onStageMatched }) => {
  const { title, description } = parseStageDescription(stage.description);

  return (
    <div className="stage_criteria_container">
      <div className="stage_criteria_body">
        <div className="_header">
          <p>Stage Criteria</p>
          {!stageMatched ? (
            <span className="_status">{"Not Matched"}</span>
          ) : (
            <span className="_match_status">{"Matched"}</span>
          )}
        </div>
        <div className="_main">
          <h2>{title}</h2>
          <p>{description}</p>
          {stageMatched ? (
            <div className="_matched_button">
              <img src={assessmentIcons.tickMark} />
              Stage Matched
            </div>
          ) : (
            <CustomButtonWithIcon
              title="Mark as Match"
              width={200}
              onClick={onStageMatched}
              bgColor={"#20C3FF"}
              color={"#FFFFFF"}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default StageCriteria;
